import { useCallback } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {cairoNormal, cairoBold} from "../utils/fontBase64";

const useGeneratePdf = () => {
  return useCallback(async (pdfContainer: HTMLElement | null, includeLink: boolean = true, action: 'open' | 'return' = 'open') => {
    if (!pdfContainer) return null;

    const canvas = await html2canvas(pdfContainer, { scale: 5, useCORS: true, logging: false });
    const imgData = canvas.toDataURL("image/jpeg");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    pdf.addFileToVFS("cairoNormal.ttf", cairoNormal);
    pdf.addFont("cairoNormal.ttf", "Cairo", "normal");

    pdf.addFileToVFS("cairoBold.ttf", cairoBold);
    pdf.addFont("cairoBold.ttf", "Cairo", "bold");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    pdf.addImage(imgData, "jpeg", 0, 0, pageWidth, pageHeight);

    if (includeLink) {
      const preLinkText = "Visit Explore Madayn ";
      const linkText = "(www.explore.madayn.om)";
      const postLinkText1 = " for more available plots and";
      const postLinkText2 = " opportunities";

      const fontSize = 16;
      const textX = 7;
      const textY = pageHeight - 15;

      pdf.setFontSize(fontSize);

      pdf.setFont("Cairo", "bold");
      pdf.setTextColor("#362044");
      pdf.text(preLinkText, textX, textY);

      const linkX = textX + pdf.getTextWidth(preLinkText);
      pdf.setFont("Cairo", "normal");
      pdf.setTextColor("#2e1a47");
      pdf.text(linkText, linkX, textY);

      pdf.link(linkX, textY - 5, pdf.getTextWidth(linkText), 10, {
        url: "https://www.explore.madayn.om",
      });

      const postLinkX = linkX + pdf.getTextWidth(linkText);
      pdf.setFont("Cairo", "bold");
      pdf.setTextColor("#362044");
      pdf.text(postLinkText1, postLinkX, textY);

      const newLineY = textY + 10;
      pdf.text(postLinkText2, textX - 1, newLineY);
    }

    const pdfBlob = pdf.output("blob");
    if (action === "open") {
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL, "_blank");
      return null;
    }
    return pdfBlob;
  }, []);
};

export default useGeneratePdf;
